import { useEffect, useState } from "react";

/**
 * The latest `value` once it has stopped changing for `delayMs`. Typeahead
 * reads use it so a word costs one round of requests, not one per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    if (Object.is(value, debounced)) return;
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, debounced, delayMs]);
  return debounced;
}
